import { Pipe, PipeTransform } from '@angular/core';

import { AccountEducation } from '@libs/src/models/account.model';
import { getReadableEducation } from '@main-client/src/app/pipes/account-readable-education-pipe/account-readable-education.helper';

@Pipe({
  name: 'accountReadableEducation',
})
export class AccountReadableEducationPipe implements PipeTransform {
  transform(value: AccountEducation): string {
    return getReadableEducation(value);
  }
}
